import { Toggle } from "../../../shared/components/Toggle";
import { track } from "../../tracker/EventTracker";
import { data } from "../../../shared/state/payload";

customElements.define(
	"esc-hotel-content-feeder",
	class extends Toggle {
		open() {
			track(
				"Hotel",
				`Ausgeklappt | ${this.trackName}`,
				`${data.hotel.id} - ${data.hotel.name}`,
			);
			super.open();
		}

		get trackName() {
			return this.getAttribute("track-name");
		}
	},
);
